import { FC } from 'react';
import { isEmpty } from 'lodash';

import tailwindConfig from '@gn-audio/jss-components/tailwind-presets/jabra-preset';
import { HexColor, isColorBright, resolveColorProperty } from '@gn-audio/jss-components/utils';

import { useBreakpoint } from 'utils/hooks/useBreakpoint';

import HtmlRender from './HtmlRender';

export interface BannerProps {
  title: string;
  body: string;
  backgroundColor: HexColor | string;
  bottomOverlapHeight?: string;
  className?: string;
}

const Banner: FC<BannerProps> = ({
  title,
  body,
  className = '',
  backgroundColor = tailwindConfig.theme.colors.green.DEFAULT,
  bottomOverlapHeight,
}) => {
  const { isAboveMd } = useBreakpoint('md', true);

  if (isEmpty(title) && isEmpty(body)) {
    return null;
  }
  const overlapStyle = bottomOverlapHeight &&
    isAboveMd && {
      paddingBottom: bottomOverlapHeight,
      marginBottom: `-${bottomOverlapHeight}`,
    };

  const backgroundColorHex =
    resolveColorProperty(backgroundColor) || tailwindConfig.theme.colors.green.DEFAULT;

  return (
    <div
      className={`text-${isColorBright(backgroundColorHex as HexColor) ? 'black' : 'white'} ${className}`}
      style={{
        backgroundColor: backgroundColorHex,
        ...overlapStyle,
      }}
    >
      <div className="container-fluid text-center">
        <div className="container">
          <h1 className="xlg:text-5xl mb-2 text-2xl font-semibold leading-10 md:mb-4 md:text-4xl">
            {title}
          </h1>
          <HtmlRender element="p" className="text-lg" html={body} />
        </div>
      </div>
    </div>
  );
};

export default Banner;
